import {useTranslation} from "react-i18next";
import React from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Title, Block } from "../../components/components";
import { Accordion, Button, Card, Col, Row } from "react-bootstrap";
import ShowItem from "../../components/ShowItem";
import { useGetPakitoAppQuery } from "../../api/pakitoApiSlice";

function PakitoShow(props) {
  const id = useParams()["id"];
  const { t } = useTranslation();
  const {data: androidApp, isSuccess} = useGetPakitoAppQuery(id);

  if( ! isSuccess) {return (<></>)}
  return(
    <>
    <Title main={t("menu.pakito")} />
    <Row>
      <Col md={6}>
        <Block title={"General"}>
          <ShowItem label={"Name"} value={androidApp.app_name} />
          <ShowItem label={"Bundle ID"} value={androidApp.bundleId} />
          <ShowItem label={"Category"} value={androidApp.category} />
          <ShowItem label={"Last seen at"} value={androidApp.last_seen_at} />
          <ShowItem label={"Installs"} value={androidApp.installs} />
          <ShowItem label={"Nb Ratings"} value={androidApp.nb_ratings} />
          <ShowItem label={"Version"} value={androidApp.app_version} />
        </Block>
      </Col>
      <Col md={6}>
        <Block title={"Developer"} >
          { androidApp.developer && <>
            <ShowItem label={"Name"} value={androidApp.developer.name} />
            <ShowItem label={"Website"} value={androidApp.developer.website} />
          </>
          }
          <ShowItem label={"Email"} value={androidApp.dev_email} />
          <ShowItem label={"Address"} value={androidApp.dev_address} />
        </Block>
        <Block title={"Price"}>
          <ShowItem label={"Price Value"} value={androidApp.price_value} />
          <ShowItem label={"Price Currency"} value={androidApp.price_currency} />
        </Block>
      </Col>
    </Row>
    <Accordion>
      <Card>
        <Accordion.Toggle as={Button} eventKey="0">
          Permission
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <Card.Body>
            { androidApp.permissions?.map((x, i)=>{
              return (<ShowItem key={i} value={x.label} />)
            })}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  </>
  )
}

export default PakitoShow